type DateLike = string | number | Date | null | undefined;

const DAY_MS = 24 * 60 * 60 * 1000;

const timeFormatter = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const weekdayFormatter = new Intl.DateTimeFormat('en-US', {
  weekday: 'long',
});

const shortDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'numeric',
  day: 'numeric',
  year: '2-digit',
});

const toDate = (value: DateLike): Date | null => {
  if (!value) return null;
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const startOfDay = (date: Date): Date => new Date(date.getFullYear(), date.getMonth(), date.getDate());

const dayDiffFromNow = (date: Date, now: Date): number =>
  Math.round((startOfDay(now).getTime() - startOfDay(date).getTime()) / DAY_MS);

const formatShortDate = (date: Date): string => shortDateFormatter.format(date);

export const formatWhatsAppBubbleTime = (dateLike: DateLike): string => {
  const date = toDate(dateLike);
  return date ? timeFormatter.format(date) : '';
};

export const formatWhatsAppRailTimestamp = (dateLike: DateLike, nowLike?: DateLike): string => {
  const date = toDate(dateLike);
  if (!date) return '';
  const now = toDate(nowLike) || new Date();
  const dayDiff = dayDiffFromNow(date, now);

  if (dayDiff === 0) return formatWhatsAppBubbleTime(date);
  if (dayDiff === 1) return 'Yesterday';
  if (dayDiff > 1 && dayDiff <= 6) return weekdayFormatter.format(date);
  return formatShortDate(date);
};

export const formatWhatsAppDateSeparator = (dateLike: DateLike, nowLike?: DateLike): string => {
  const date = toDate(dateLike);
  if (!date) return 'Timeline';
  const now = toDate(nowLike) || new Date();
  const dayDiff = dayDiffFromNow(date, now);

  if (dayDiff === 0) return 'Today';
  if (dayDiff === 1) return 'Yesterday';
  if (dayDiff > 1 && dayDiff <= 6) return weekdayFormatter.format(date);
  return formatShortDate(date);
};

export const formatWhatsAppDateTimeDetail = (dateLike: DateLike, nowLike?: DateLike): string => {
  const date = toDate(dateLike);
  if (!date) return '';
  return `${formatWhatsAppDateSeparator(date, nowLike)} • ${formatWhatsAppBubbleTime(date)}`;
};

// Examples:
// today 13:15 -> 13:15
// yesterday -> Yesterday
// 3 days ago -> Saturday
// older -> 5/8/26
